<div class="container">
  <div class="row">
    <div class="col col-12" style="flex-basis: max-content; margin: auto;">
      <ngx-charts-pie-chart class="text-center" [view]="[120,120]" [scheme]="trafficLightPalette" [results]="ratings" [legend]="false"
        [explodeSlices]="false" [labels]="false" [doughnut]="true" [gradient]="false">
      </ngx-charts-pie-chart>
    </div>
    <div class="col col-12 text-center">
      <span class="h1 font-weight-bold text-primary" style="font-size:2.0vw; ">{{positiveRating | number: '1.0-0'}}%</span>
    </div>
    <div class="col col-12 text-center">
      <span class="text-3 text-primary">Positive Rating</span>
    </div>
  </div>
</div>